import { useRouter } from 'vue-router';

import SettingsRouteName from '@/features/settings/SettingsRouteName';

import { useFacebookBetaStatus } from './useFacebookBeta';
import useIsCurrentUserCanViewFacebook from './useIsCurrentUserCanViewFacebook';

export default function useFacebookPageRouterGuard() {
  const router = useRouter();

  const { isEnabled: isFacebookBetaEnabled } = useFacebookBetaStatus();
  const isCurrentUserCanViewFacebook = useIsCurrentUserCanViewFacebook();

  router.beforeEach((to, _, next) => {
    if (to.name !== 'facebook') {
      next();
      return;
    }

    if (!isFacebookBetaEnabled.value) {
      next({ name: SettingsRouteName.FACEBOOK_SETTINGS });
      return;
    }

    if (!isCurrentUserCanViewFacebook.value) {
      next({ name: 'campaigns' });
      return;
    }

    next();
  });
}
